import * as broker from './broker';

let user = null;

export function get() {
    return user;
}

export function set(u) {
    user = u;
    broker.publish('userSet');
}
